/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
const vimeTags = [
    'vm-audio',
    'vm-caption-control',
    'vm-captions',
    'vm-click-to-play',
    'vm-control',
    'vm-control-group',
    'vm-control-spacer',
    'vm-controls',
    'vm-current-time',
    'vm-dailymotion',
    'vm-dash',
    'vm-dbl-click-fullscreen',
    'vm-default-controls',
    'vm-default-settings',
    'vm-default-ui',
    'vm-embed',
    'vm-end-time',
    'vm-file',
    'vm-fullscreen-control',
    'vm-hls',
    'vm-icon',
    'vm-icon-library',
    'vm-live-indicator',
    'vm-loading-screen',
    'vm-menu',
    'vm-menu-item',
    'vm-menu-radio',
    'vm-menu-radio-group',
    'vm-mute-control',
    'vm-pip-control',
    'vm-playback-control',
    'vm-player',
    'vm-poster',
    'vm-scrim',
    'vm-scrubber-control',
    'vm-settings',
    'vm-settings-control',
    'vm-skeleton',
    'vm-slider',
    'vm-spinner',
    'vm-submenu',
    'vm-time',
    'vm-time-progress',
    'vm-tooltip',
    'vm-ui',
    'vm-video',
    'vm-vimeo',
    'vm-volume-control',
    'vm-youtube',
];
Vue.config.ignoredElements = [...Vue.config.ignoredElements, ...vimeTags];
import AudioProxy from './Audio';
import CaptionControlProxy from './CaptionControl';
import CaptionsProxy from './Captions';
import ClickToPlayProxy from './ClickToPlay';
import ControlProxy from './Control';
import ControlGroupProxy from './ControlGroup';
import ControlSpacerProxy from './ControlSpacer';
import ControlsProxy from './Controls';
import CurrentTimeProxy from './CurrentTime';
import DailymotionProxy from './Dailymotion';
import DashProxy from './Dash';
import DblClickFullscreenProxy from './DblClickFullscreen';
import DefaultControlsProxy from './DefaultControls';
import DefaultSettingsProxy from './DefaultSettings';
import DefaultUiProxy from './DefaultUi';
import EmbedProxy from './Embed';
import EndTimeProxy from './EndTime';
import FileProxy from './File';
import FullscreenControlProxy from './FullscreenControl';
import HlsProxy from './Hls';
import IconProxy from './Icon';
import IconLibraryProxy from './IconLibrary';
import LiveIndicatorProxy from './LiveIndicator';
import LoadingScreenProxy from './LoadingScreen';
import MenuProxy from './Menu';
import MenuItemProxy from './MenuItem';
import MenuRadioProxy from './MenuRadio';
import MenuRadioGroupProxy from './MenuRadioGroup';
import MuteControlProxy from './MuteControl';
import PipControlProxy from './PipControl';
import PlaybackControlProxy from './PlaybackControl';
import PlayerProxy from './Player';
import PosterProxy from './Poster';
import ScrimProxy from './Scrim';
import ScrubberControlProxy from './ScrubberControl';
import SettingsProxy from './Settings';
import SettingsControlProxy from './SettingsControl';
import SkeletonProxy from './Skeleton';
import SliderProxy from './Slider';
import SpinnerProxy from './Spinner';
import SubmenuProxy from './Submenu';
import TimeProxy from './Time';
import TimeProgressProxy from './TimeProgress';
import TooltipProxy from './Tooltip';
import UiProxy from './Ui';
import VideoProxy from './Video';
import VimeoProxy from './Vimeo';
import VolumeControlProxy from './VolumeControl';
import YoutubeProxy from './Youtube';
export const Audio = /*#__PURE__*/ AudioProxy;
export const CaptionControl = /*#__PURE__*/ CaptionControlProxy;
export const Captions = /*#__PURE__*/ CaptionsProxy;
export const ClickToPlay = /*#__PURE__*/ ClickToPlayProxy;
export const Control = /*#__PURE__*/ ControlProxy;
export const ControlGroup = /*#__PURE__*/ ControlGroupProxy;
export const ControlSpacer = /*#__PURE__*/ ControlSpacerProxy;
export const Controls = /*#__PURE__*/ ControlsProxy;
export const CurrentTime = /*#__PURE__*/ CurrentTimeProxy;
export const Dailymotion = /*#__PURE__*/ DailymotionProxy;
export const Dash = /*#__PURE__*/ DashProxy;
export const DblClickFullscreen = /*#__PURE__*/ DblClickFullscreenProxy;
export const DefaultControls = /*#__PURE__*/ DefaultControlsProxy;
export const DefaultSettings = /*#__PURE__*/ DefaultSettingsProxy;
export const DefaultUi = /*#__PURE__*/ DefaultUiProxy;
export const Embed = /*#__PURE__*/ EmbedProxy;
export const EndTime = /*#__PURE__*/ EndTimeProxy;
export const File = /*#__PURE__*/ FileProxy;
export const FullscreenControl = /*#__PURE__*/ FullscreenControlProxy;
export const Hls = /*#__PURE__*/ HlsProxy;
export const Icon = /*#__PURE__*/ IconProxy;
export const IconLibrary = /*#__PURE__*/ IconLibraryProxy;
export const LiveIndicator = /*#__PURE__*/ LiveIndicatorProxy;
export const LoadingScreen = /*#__PURE__*/ LoadingScreenProxy;
export const Menu = /*#__PURE__*/ MenuProxy;
export const MenuItem = /*#__PURE__*/ MenuItemProxy;
export const MenuRadio = /*#__PURE__*/ MenuRadioProxy;
export const MenuRadioGroup = /*#__PURE__*/ MenuRadioGroupProxy;
export const MuteControl = /*#__PURE__*/ MuteControlProxy;
export const PipControl = /*#__PURE__*/ PipControlProxy;
export const PlaybackControl = /*#__PURE__*/ PlaybackControlProxy;
export const Player = /*#__PURE__*/ PlayerProxy;
export const Poster = /*#__PURE__*/ PosterProxy;
export const Scrim = /*#__PURE__*/ ScrimProxy;
export const ScrubberControl = /*#__PURE__*/ ScrubberControlProxy;
export const Settings = /*#__PURE__*/ SettingsProxy;
export const SettingsControl = /*#__PURE__*/ SettingsControlProxy;
export const Skeleton = /*#__PURE__*/ SkeletonProxy;
export const Slider = /*#__PURE__*/ SliderProxy;
export const Spinner = /*#__PURE__*/ SpinnerProxy;
export const Submenu = /*#__PURE__*/ SubmenuProxy;
export const Time = /*#__PURE__*/ TimeProxy;
export const TimeProgress = /*#__PURE__*/ TimeProgressProxy;
export const Tooltip = /*#__PURE__*/ TooltipProxy;
export const Ui = /*#__PURE__*/ UiProxy;
export const Video = /*#__PURE__*/ VideoProxy;
export const Vimeo = /*#__PURE__*/ VimeoProxy;
export const VolumeControl = /*#__PURE__*/ VolumeControlProxy;
export const Youtube = /*#__PURE__*/ YoutubeProxy;
//# sourceMappingURL=index.js.map